export const QUIET_HOURS_BANNER_PERMANENT_HIDE_COUNT = 3
export const QUIET_HOURS_MODAL_SENT_ONCE_KEY = 'quiet_hours_modal_sent_once'
export const QUIET_HOURS_ALLOWED_TIME_FROM = '09:00'
export const QUIET_HOURS_ALLOWED_TIME_TO = '20:00'
